var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 58,
    viewBox: "0 0 50 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6429 25H41.9643V16.9643C41.9643 7.61161 34.3527 0 25 0C15.6473 0 8.03571 7.61161 8.03571 16.9643V25H5.35714C2.39955 25 0 27.3996 0 30.3571V51.7857C0 54.7433 2.39955 57.1429 5.35714 57.1429H44.6429C47.6004 57.1429 50 54.7433 50 51.7857V30.3571C50 27.3996 47.6004 25 44.6429 25ZM33.0357 25H16.9643V16.9643C16.9643 12.5335 20.5692 8.92857 25 8.92857C29.4308 8.92857 33.0357 12.5335 33.0357 16.9643V25Z",
    fill: "#CBD9F7",
    fillOpacity: 0.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.43fa3cf551dc5e6ef0a0f0d80aca6e2d.svg";
export { ForwardRef as ReactComponent };